import _ from 'lodash';
import { t } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import ListFormField from '../../form/ListFormField';
import { IP_RULE_FIELD } from '../../ip-form/IpFormConstants';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { getNotifyTableColumns, NOTIFICATIONS_NOTIFY_FIELD } from './NotificationPolicyConstants';
import EditNotifyForm from './EditNotifyForm';

const addButtonText = t`Add Email`;
const noEmailText = t`Click the Add Email button above to add a new email notification`;
const initialSortRules = [{ property: IP_RULE_FIELD, direction: SORT_ASC }];

export default function EmailNotifications(props) {
    const { notification, setNotifySelectionIsDirty, selectedType } = props;

    if (_.isEmpty(notification)) {
        return null;
    }

    return (
        <FormSection title={t`Email Notifications`} addSpacer>
            <ListFormField
                fieldName={NOTIFICATIONS_NOTIFY_FIELD}
                dbSelected={_.get(notification, NOTIFICATIONS_NOTIFY_FIELD)}
                addButtonText={addButtonText}
                gridColumns={getNotifyTableColumns(selectedType)}
                emptyGridText={noEmailText}
                formComponent={<EditNotifyForm notifyRecords={notification.notify} selectedType={selectedType} />}
                selectedListSorter={initialSortRules}
                setSelectionIsDirty={setNotifySelectionIsDirty}
                showGridToolbar
                showSearch
                visibleRows={8}
            />
        </FormSection>
    );
}
